import qs from 'qs'

import { Metable } from '../../types/metable'
import { getRequest } from '../../utils'
import type { BankPayment } from './types/bankPayment'
import { TransactionPostingsData } from './types/transactionPostingsData'

export interface ContactBalancePayment {
  amount: number
  contactId: string
  createdTime: string
  currencyId: string
  entryDate: string
  isVoided: boolean
  organizationId: string
  side: string
}

interface FetchContactBalancePaymentResponseData extends Metable {
  contactBalancePayment: ContactBalancePayment
}

export const fetchContactBalancePayment = (
  contactBalancePaymentId: string,
): Promise<FetchContactBalancePaymentResponseData> =>
  getRequest(`/v2/contactBalancePayments/${contactBalancePaymentId}`)

export interface InvoiceLateFee {
  amount: number
  createdTime: string
  entryDate: string
  flatFee: number
  id: string
  invoiceId: string
  isVoided: boolean
  percentageFee: number
}

interface FetchInvoiceLateFeeResponseData extends Metable {
  invoiceLateFee: InvoiceLateFee
}

export const fetchInvoiceLateFee = (invoiceLateFeeId: string): Promise<FetchInvoiceLateFeeResponseData> =>
  getRequest(`/v2/invoiceLateFees/${invoiceLateFeeId}`)

export interface ConversionBalance {
  accountId: string
  amount: number
  conversionBalanceId: string
  id: string
}

interface FetchConversionBalanceResponseData extends Metable {
  conversionBalanceLines: ConversionBalance[]
}

export const fetchConversionBalance = (conversionBalanceId: string): Promise<FetchConversionBalanceResponseData> =>
  getRequest(`/v2/conversionBalanceLines?conversionBalanceId=${conversionBalanceId}`)

export const getTransactionPostings = (transactionId: string): Promise<TransactionPostingsData> =>
  getRequest(`/v2/postings?transactionId=${transactionId}`)

export interface BalanceModifier {
  amount: number | null
  entryDate: string | null
  id: string
  isVoided: boolean
  modifierReference: string | null
  realizedCurrencyDifference: number | null
  subjectReference: string | null
}

interface FetchBalanceModifiersResponseData extends Metable {
  balanceModifiers: BalanceModifier[]
}

export const fetchBalanceModifiers = (modifierReference: string): Promise<FetchBalanceModifiersResponseData> =>
  getRequest(`/v2/balanceModifiers?${qs.stringify({ modifierReference })}`)

export interface ContactBalancePosting {
  amount: number | null
  currencyId: string
  entryDate: string
  id: string
  isVoided: boolean
  originatorReference: string | null
  side: string
}

interface FetchContactBalancePostingsResponseData extends Metable {
  contactBalancePostings: ContactBalancePosting[]
}

export const fetchContactBalancePostings = (
  originatorReference: string,
): Promise<FetchContactBalancePostingsResponseData> =>
  getRequest(`/v2/contactBalancePostings?${qs.stringify({ originatorReference })}`)

interface FetchBankPaymentResponseData extends Metable {
  bankPayment: BankPayment
}

export const fetchBankPayment = (bankPaymentId: string): Promise<FetchBankPaymentResponseData> =>
  getRequest(`/v2/bankPayments/${bankPaymentId}`)
